var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationIcon = function SvgLocationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9488_17458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5785 4.39633V4.39633C17.1072 6.92497 17.1072 11.0247 14.5785 13.5534L11.0789 17.053V17.053C10.4831 17.6488 9.51695 17.6488 8.92107 17.053L5.42148 13.5534L5.42148 13.5534C2.89284 11.0247 2.89284 6.92497 5.42148 4.39633V4.39633L5.42148 4.39633C7.95013 1.86768 12.0499 1.86768 14.5785 4.39633L14.5785 4.39633Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9488_17458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export { SvgLocationIcon as ReactComponent };
export default __webpack_public_path__ + "location-icon.svg";